export default {
    locale: 'ru',
    country: 'RU',
    loginForm: {
        byAccountBtn: 'Аккаунт пароль логин',
        byPhoneBtn: 'Вход по мобильному номеру',
        accountPlaceholder: 'Пожалуйста, введите учетную запись (учетная запись по умолчанию ADMIN)',
        passwordPlaceholder: 'Пожалуйста, введите пароль (пароль по умолчанию 123456)',
        autoLogin: 'автоматическая авторизация',
        forgetBtn: 'Забыл пароль',
        loginBtn: 'авторизоваться',
        byAccountTip: {
            emptyErr: 'Аккаунт не может быть пустым'
        },
        byPasswordTip: {
            emptyErr: 'пароль не может быть пустым'
        },
        byValidTip: {
            emptyErr: 'код подтверждения должен быть заполнен'
        },
        sendMsg: {
            repeatErr: 'Не отправлять повторно',
            success: 'Успешный',
            codeTip: 'Ваш проверочный код'
        },
        phonePlaceholder: 'Пожалуйста, введите номер телефона',
        validPlaceholder: 'код подтверждения',
        validBtn: 'получить код подтверждения',
        loginSuccess: 'Авторизация успешна'
    },
    menuObj: {
        basicFeature: 'Базовая способность',
        cpUse: 'Использование компонентов',
        childMenu: {
            0: 'Базовая структура',
            1: 'Базовая способность',
            '0-0': 'Vue',
            '0-1': 'Муравей Дизайн',
            '0-2': 'Рядом с администратором Vue',
            '1-0': 'Рамочная функция',
            '1-0-0': 'Конфигурация проекта',
            '1-0-1': 'Журнал веб-интерфейса',
            '1-0-2': 'Местный макет',
            '1-0-3': 'глобализация',
            '1-0-4': 'Словарь с данными',
            '1-0-5': 'EventBus',
            '1-0-6': 'Набор инструментов',
            '1-0-7': 'Контроль доступа',
            '1-0-8': 'горячая клавиша',
            '1-1': 'Функция страницы',
            '1-1-0': 'Компонентная страница',
            '1-1-1': 'URL-адрес страницы',
            '1-1-2': 'Страница без разрешений',
            '1-1-3': '404 стр.'
        },
        errorTip: {
            notfoundTip: 'Компонент по этому пути не найден',
            emptyErr: 'Путь к ненастроенным компонентам'
        }
    },
    coreMenuObj: {
        defaultMenu: {
            home: 'Дома'
        }
    },
    sysInfo: {
        sysIntro: 'Полезный фреймворк для разработки среднего и внутреннего интерфейса на основе Vue и Ant Design.'
    },
    requestInfo: {
        withoutUrl: 'Адрес запроса не может быть пустым',
        networkErr: 'Ошибка сетевого запроса, повторите попытку позже'
    },
    localeMap: {
        ar: 'арабский',
        bg: 'болгарский',
        ca: 'Каталонский',
        cs: 'Чешский',
        da: 'Датский',
        de: 'Немецкий',
        el: 'Греческий',
        'en-gb': 'английский',
        en: 'английский',
        es: 'испанский',
        et: 'эстонский',
        fa: 'Персидский',
        fi: 'Финский',
        fr: 'Французский',
        he: 'иврит',
        hi: 'хинди',
        hr: 'хорватский',
        hu: 'Венгерский',
        hy: 'Армянский',
        id: 'индонезийский',
        is: 'исландский',
        it: 'Итальянский',
        ja: 'Японский',
        kn: 'Каннада',
        ko: 'Корейский',
        'ku-iq': 'Центральнокурдский',
        lv: 'Центральнокурдский',
        mk: 'македонский',
        'mn-mn': 'Монгольский',
        'ms-my': 'малайский',
        nb: 'норвежский язык',
        'ne-np': 'Непальский',
        'nl-be': 'Фламандский',
        nl: 'нидерландский язык',
        pl: 'Польский',
        'pt-br': 'бразильский португальский',
        pt: 'Европейский португальский',
        ro: 'румынский',
        ru: 'русский язык',
        sk: 'словацкий',
        sl: 'словенский',
        sr: 'сербский',
        sv: 'Шведский',
        ta: 'Тамильский',
        th: 'Тайский',
        tr: 'турецкий',
        uk: 'украинец',
        vi: 'вьетнамский',
        'zh-cn': 'Упрощенный китайский',
        'zh-tw': 'традиционный китайский'
    },
    tagObj: {
        closeAll: 'Закройте все вкладки',
        closeCur: 'Закрыть текущая вкладка',
        closeOther: 'Закройте другие вкладки',
        closeRight: 'Закрыть правую этикетку',
        singlePage: 'Независимая страница',
        refreshPage: 'обновить страницу',
        affixPage: 'Закрепить страницу',
        cancelAffixPage: 'Открепить',
        errorTip: {
            homePageCloseError: 'Домашняя страница не может быть закрыта',
            affixPageCloseError: 'Фиксированная страница не может быть закрыта',
            homePageAffixError: 'Домашнюю страницу нельзя открепить'
        },
        checkSave: 'Вы хотите закрыть страницу? (Убедитесь, что содержимое страницы, отмеченной красным, было сохранено)',
        cancelClose: 'Операция закрытия отменена'
    },
    personalCenter: {
        frontendLog: 'Журнал веб-интерфейса',
        customSetting: 'Персонализация',
        customClean: 'Очистить конфигурацию',
        cacheClean: 'Очистить кэш',
        logout: 'выход',
        errorTip: {
            cleanSuccess: 'Очистить успешно'
        }
    },
    errorPage: {
        errorTip: {
            notfoundTip: 'Извините, посещенная вами страница не существует',
            notrightTip: 'Извините, у вас нет разрешения на доступ к этой странице',
            noserviceTip: 'Извините, возникла проблема с сервером, повторите попытку позже'
        },
        btnText: 'Закрыть страницу'
    },
    searchPanel: {
        btn: {
            search: 'Узнать',
            shrink: 'Убрать',
            reset: 'Перезагрузить',
            unshrink: 'Развернуть'
        }
    },
    logline: {
        list: 'Список журналов',
        detail: 'Детали журнала',
        btnList: {
            export: 'Экспорт',
            remove: 'Пустой'
        },
        time: {
            plh: 'Пожалуйста, выберите временной диапазон',
            range: 'лимит времени',
            halfDay: 'Пол дня',
            oneDay: 'В течение одного дня',
            weekDay: 'в течении недели',
            monthDay: 'В течение месяца'
        },
        type: {
            logType: 'Тип журнала',
            plh: 'Пожалуйста, выберите тип журнала'
        },
        tableColumns: {
            index: 'Серийный номер',
            desc: 'Описание журнала',
            type: 'Тип журнала',
            time: 'время',
            op: 'действующий'
        },
        request: 'Данные запроса',
        error: {
            cancel: 'Пустая операция отменена',
            confirm: 'Вы хотите очистить журнал? (Если журнал очищен, его нельзя будет восстановить)'
        },
        success: 'Журнал был очищен'
    },
    comTable: {
        delete: {
            title: 'Очистить конфигурацию'
        },
        columns: {
            title: 'Настройки столбца',
            all: 'выбрать все',
            reset: 'Перезагрузить',
            fixedLeft: 'Фиксированный слева',
            fixedRight: 'Фиксированная правая',
            cancelFixed: 'Открепить'
        },
        size: {
            title: 'Высота строки',
            small: 'узкий',
            normal: 'в',
            large: 'ширина'
        },
        fullscreen: 'полноэкранный',
        unFullscreen: 'Отменить полноэкранный режим'
    },
    normalBtn: {
        detail: 'Вид'
    },
    setting: {
        customEntry: 'Быстрый вход',
        systemSwitch: 'Конфигурация системы',
        isMock: 'Ли насмешка',
        isHotKey: 'Быстрая клавиша',
        isBreadCrumb: 'Будь то панировочные сухари',
        isCache: 'Кэшировать',
        isI18n: 'Следует ли интернационализировать'
    },
    pagingInfo: {
        total: 'В итоге',
        uint: 'Статья',
        items: 'запись'
    }
}
